<div class="note-info" [class.fill-space]="fillSpace === true" [ngClass]="note.customClass">
  @if (note.type) {
    <strong>{{ note.type | translate }}:&nbsp;</strong>
  }
  @if (note.iconBeforeText) {
    <span class="icon-before-text">
      <span class="material-icons-outlined">{{ note.iconBeforeText }}</span>
    </span>
  }
  <span [innerHTML]="$safeNavigationMigration(note?.message) | translate: note?.messageParams"></span>
  @if (!!note?.link) {
    <a href="{{ note?.link }}" target="kb">&nbsp;{{ note?.textLink | translate }}</a>
  }
  @if (!!note?.action || !!note?.secondaryAction) {
    <p class="actions-container">
      @if (!!note?.secondaryAction) {
        <button [ngClass]="note.secondaryBtnClass" mat-stroked-button class="secondary-button" (click)="note.secondaryAction()">
          {{ note?.secondaryTextLink | translate }}
        </button>
      }
      @if (!!note?.action) {
        <button [ngClass]="note.firstBtnClass" mat-stroked-button class="primary-button" (click)="note.action()">
          {{ note?.textLink | translate }}
        </button>
      }
    </p>
  }
  @if (!!note?.closeAction) {
    <mat-icon class="close-icon" (click)="note.closeAction()">close</mat-icon>
  }
</div>
